export class ProfitProductSale {
    name: string;
    quantity: number;
    total: number;
    subTotal: number;
    tax: number;

    constructor(pName: string, pQuantity: number, pSubTotal: number, pTax: number) {
        this.name = pName;
        this.quantity = pQuantity;
        this.subTotal = pSubTotal;
        this.tax = pTax;
        this.total = this.subTotal + this.tax;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/accounting/shared/models/profit-product-sale.ts